export default "__VITE_ASSET__Bg52RyF6__"